export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7546.418e5112.jpg";